module.exports = __webpack_public_path__ + "static/media/inventree.489b4a08.png";